import { useState } from "react";
import { api, surveyConfigFrom, type SurveyConfig } from "../../api";
import { useEditor } from "../DemoEditor";

/** Survey and Outcomes steps edit one shared config that saves atomically. */
export function useSurveyDraft() {
  const { bundle, setBundle, setDirty } = useEditor();
  const [cfg, setCfgState] = useState<SurveyConfig>(() => surveyConfigFrom(bundle));
  const [dirty, setLocalDirty] = useState(false);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState<{ ok: boolean; text: string } | null>(null);

  const setCfg = (next: SurveyConfig) => {
    setCfgState(next);
    setLocalDirty(true);
    setDirty(true);
    setMsg(null);
  };
  const save = async (): Promise<boolean> => {
    setSaving(true);
    try {
      const b = await api.saveSurvey(bundle.demo.id, cfg);
      setBundle(b);
      setCfgState(surveyConfigFrom(b));
      setLocalDirty(false);
      setDirty(false);
      setMsg({ ok: true, text: "Saved" });
      return true;
    } catch (e: any) {
      setMsg({ ok: false, text: e.message });
      return false;
    } finally {
      setSaving(false);
    }
  };
  return { cfg, setCfg, save, dirty, saving, msg };
}

export function move<T>(arr: T[], i: number, dir: -1 | 1): T[] {
  const j = i + dir;
  if (j < 0 || j >= arr.length) return arr;
  const out = [...arr];
  [out[i], out[j]] = [out[j], out[i]];
  return out;
}
